import React, { useEffect, useState } from "react";
import Dialog from "../../CoreComponent/Dialog";
import ImageUpload from "../../CoreComponent/ImageUpload";
import "./style.scss";
import httpService from "../../common/httpService";
import toast from "react-hot-toast";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { IconButton, Menu, MenuItem } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

const VisaFiles = () => {
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [file, setFile] = useState(null);
  const [id, setId] = useState(null);

  const [data, setData] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [loading, setLoading] = useState(false);

  const BaseUrl = process.env.REACT_APP_BASE_URL;

  const openMenu = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const closeMenu = () => {
    setAnchorEl(null);
    setSelectedRow(null);
  };

  const handleUploadClick = (row) => {
    setSelectedUser(row);
    setId(row.id);
    setFile(null);
    setDialogOpen(true);
    closeMenu();
  };

  const getData = async () => {
    const authToken = localStorage.getItem("token");

    if (!authToken) {
      toast.error("Authentication token not found.");
      return;
    }

    try {
      setLoading(true);

      const result = await httpService({
        method: "GET",
        url: `${BaseUrl}/completed/visa`,
        headers: {
          Authorization: `Bearer ${authToken}`,
          Accept: "application/json",
        },

        onSuccess: (response) => {
          console.log("Completed visa API response:", response);

          // Different possible response structures handle kar rahe hain
          const responseData = response?.data ?? response;

          const visas = Array.isArray(responseData)
            ? responseData
            : responseData?.visas ??
              responseData?.data ??
              responseData?.results ??
              [];

          console.log("Visa records:", visas);

          const formattedData = visas
            .map((item, index) => {
              const visa = item?.visa ?? item;
              const user = item?.user ?? {};

              const visaId =
                visa?.id ??
                item?.visa_id ??
                item?.id ??
                `visa-${index}`;

              return {
                id: visaId,
                name: user?.name ?? item?.name ?? "-",
                email: user?.email ?? item?.email ?? "-",
                status: visa?.status ?? item?.status ?? "-",
              };
            })
            .filter((item) => item.id);

          setData(formattedData);
        },

        onError: (error) => {
          console.error("Failed to fetch completed visa data:", error);

          toast.error(
            error?.response?.data?.message ||
              error?.message ||
              "Failed to fetch visa data."
          );

          setData([]);
        },
      });
    } catch (error) {
      console.error("Failed to fetch completed visa data:", error);

      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          "Failed to fetch visa data."
      );

      setData([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    if (!file) {
      toast.error("Please select a visa file first.");
      return;
    }

    if (!id) {
      toast.error("Visa record ID is missing.");
      return;
    }

    const formData = new FormData();
    formData.append("visapdf", file);

    const authToken = localStorage.getItem("token");

    try {
      await httpService({
        method: "POST",
        url: `${BaseUrl}/add/visaPDF/${id}`,
        headers: {
          Authorization: `Bearer ${authToken}`,
          Accept: "application/json",
        },
        data: formData,

        onSuccess: (response) => {
          console.log("Visa file upload response:", response);

          toast.success("File uploaded successfully!");

          setDialogOpen(false);
          setSelectedUser(null);
          setFile(null);
          setId(null);

          // Upload ke baad updated data fetch
          getData();
        },

        onError: (error) => {
          console.error("Failed to upload visa file:", error);

          toast.error(
            error?.response?.data?.message ||
              error?.message ||
              "Failed to upload visa file."
          );
        },
      });
    } catch (error) {
      console.error("Failed to upload visa file:", error);

      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          "Failed to upload visa file."
      );
    }
  };

  const columns = [
    {
      field: "id",
      headerName: "ID",
      flex: 1,
      minWidth: 230,
      cellClassName: "centered-cell",
    },
    {
      field: "name",
      headerName: "User Name",
      flex: 1,
      minWidth: 230,
      cellClassName: "centered-cell",
    },
    {
      field: "email",
      headerName: "Email",
      flex: 1,
      minWidth: 230,
      cellClassName: "centered-cell",
    },
    {
      field: "status",
      headerName: "Visa Status",
      flex: 1,
      minWidth: 230,
      cellClassName: "centered-cell",
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      minWidth: 230,
      sortable: false,
      filterable: false,
      cellClassName: "centered-cell",

      renderCell: (params) => (
        <>
          <IconButton
            onClick={(event) => openMenu(event, params.row)}
            aria-label="visa actions"
          >
            <MoreVertIcon />
          </IconButton>

          <Menu
            anchorEl={anchorEl}
            open={
              Boolean(anchorEl) &&
              selectedRow?.id === params.row.id
            }
            onClose={closeMenu}
          >
            <MenuItem onClick={() => handleUploadClick(params.row)}>
              Upload Visa File
            </MenuItem>
          </Menu>
        </>
      ),
    },
  ];

  useEffect(() => {
    getData();
  }, []);

  return (
    <div className="visa-files-container">
      <h1
        className="visa-files"
        style={{
          color: "#9B1321",
        }}
      >
        Visa Files
      </h1>

      <DataGrid
        rows={data}
        columns={columns}
        getRowId={(row) => row.id}
        loading={loading}
        getRowHeight={() => "auto"}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 5,
            },
          },
        }}
        pageSizeOptions={[5]}
        checkboxSelection
        disableRowSelectionOnClick
        autoHeight
        sx={{
          marginTop: "20px",
          "& .MuiDataGrid-virtualScroller": {
            overflow: "hidden",
          },
        }}
      />

      {isDialogOpen && (
        <Dialog
          viewHeader={true}
          header="Upload Visa File"
          open={isDialogOpen}
          setOpen={setDialogOpen}
        >
          <div className="dialog-content-files">
            <div className="file-con">
              <ImageUpload
                required
                label="Visa File"
                allowedExtensions={["pdf", "jpg", "jpeg", "png"]}
                inputValue={file}
                setInputValue={setFile}
                className="image-upload"
                placeholder="Choose a file"
              />
            </div>

            <div className="buttons-file">
              <button
                className="save-button"
                onClick={handleSubmit}
                disabled={!file}
              >
                Save
              </button>

              <button
                className="cancel-button"
                onClick={() => {
                  setDialogOpen(false);
                  setFile(null);
                  setId(null);
                  setSelectedUser(null);
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </Dialog>
      )}
    </div>
  );
};

export default VisaFiles;